module.exports = __webpack_public_path__ + "img/53.5fb2cc22.png";